import { EXPORT_TOP_FLOP_DEFAULT_SORT_KPI } from './constants/exportTopFlopDefaultSortKpi.constant.js';
import { EXPORT_TOP_FLOP_SORT_KPI_PER_DATATABLE } from './constants/exportTopFlopSortKpiPerDatatable.constant.js';
/**
 * Returns the Top/Flop sorting KPIs for a given data table view.
 */
export function getTopFlopSortKpi(dataTableViewType) {
    const amount = EXPORT_TOP_FLOP_SORT_KPI_PER_DATATABLE[dataTableViewType]?.amount === undefined
        ? EXPORT_TOP_FLOP_DEFAULT_SORT_KPI.amount
        : EXPORT_TOP_FLOP_SORT_KPI_PER_DATATABLE[dataTableViewType]?.amount;
    const quantity = EXPORT_TOP_FLOP_SORT_KPI_PER_DATATABLE[dataTableViewType]?.quantity === undefined
        ? EXPORT_TOP_FLOP_DEFAULT_SORT_KPI.quantity
        : EXPORT_TOP_FLOP_SORT_KPI_PER_DATATABLE[dataTableViewType]?.quantity;
    return { amount, quantity };
}
//# sourceMappingURL=datatable.utils.js.map